const colors = 
    {
        gray: "#CCCCCC",
        red: "rgb(213, 69, 68)",
        white:"white"
    }

export default colors